const getFormatCatergory = (format) => {
    const parts = format.split("/");
    return parts[0].toUpperCase();
};

export default getFormatCatergory;
